import { formatDateRu, formatTimeRu } from "./appointmentLabels";
import {
  sessionScheduleFromIso,
  sessionScheduleToIso,
} from "../components/Clinic/AdminSchedule/calendarUtils";

export const EMPTY_COMPETITION_FORM = {
  venue_name: "",
  venue_address: "",
  assembly_date: "",
  assembly_time: "",
  event_description: "",
  contact_info: "",
  cover_image_url: "",
};

export function competitionFormFromSession(sess) {
  const base = {
    venue_name: sess?.venue_name || "",
    venue_address: sess?.venue_address || "",
    event_description: sess?.event_description || "",
    contact_info: sess?.contact_info || "",
    cover_image_url: sess?.cover_image_url || "",
    assembly_date: "",
    assembly_time: "",
  };
  if (!sess?.assembly_datetime) return base;
  const assembly = sessionScheduleFromIso(
    sess.assembly_datetime,
    sess.assembly_datetime,
  );
  return {
    ...base,
    assembly_date: assembly.date || "",
    assembly_time: assembly.startTime || "",
  };
}

export function competitionPayloadFromForm(form) {
  let assembly_datetime = null;
  if (form.assembly_date && form.assembly_time) {
    const { start } = sessionScheduleToIso({
      date: form.assembly_date,
      startTime: form.assembly_time,
      endTime: form.assembly_time,
    });
    assembly_datetime = start;
  }
  return {
    venue_name: form.venue_name?.trim() || null,
    venue_address: form.venue_address?.trim() || null,
    assembly_datetime,
    event_description: form.event_description?.trim() || null,
    contact_info: form.contact_info?.trim() || null,
  };
}

export function competitionVenueLine(comp) {
  if (comp?.venue_name && comp?.venue_address) {
    return `${comp.venue_name}, ${comp.venue_address}`;
  }
  return comp?.venue_name || comp?.venue_address || comp?.branch?.name || null;
}

export function competitionAssemblyLabel(comp) {
  if (!comp?.assembly_datetime) return null;
  return `Сбор ${formatDateRu(comp.assembly_datetime, {
    weekday: "short",
    day: "numeric",
    month: "short",
  })} · ${formatTimeRu(comp.assembly_datetime)}`;
}

export function competitionUiState(comp) {
  const reg =
    comp?.my_registration ||
    (comp?.competition_registration_status
      ? { status: comp.competition_registration_status }
      : null);

  if (reg?.status === "approved") {
    return {
      canApply: false,
      badge: "participating",
      label: "Вы участвуете",
      hint: reg.added_by_trainer ? "Тренер добавил вас в список" : null,
    };
  }
  if (reg?.status === "pending") {
    return {
      canApply: false,
      badge: "pending",
      label: "Заявка на рассмотрении",
      hint: "Тренер рассмотрит заявку",
    };
  }
  if (reg?.status === "rejected") {
    return {
      canApply: true,
      badge: "rejected",
      label: "Заявка отклонена",
      hint: "Можно подать заявку снова",
    };
  }
  return {
    canApply: true,
    badge: "open",
    label: null,
    hint: null,
  };
}

export function clubEventTag(session) {
  if (session?.session_kind !== "event") return null;
  if (session.event_kind === "competition") return "Соревнование";
  return "Событие";
}
